/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsCompanyPaymentOutput } from "../../entities/models/CompanyPaymentOutput";
import { z } from "zod/v4";

export const modelsCompanyPaymentOutputSchema = z.object({
    "amount": z.optional(z.number()),
"branch_id": z.optional(z.int()),
"branch_name": z.optional(z.string()),
"created_at": z.optional(z.string()),
"gateway_payment_id": z.optional(z.string()),
"id": z.optional(z.int()),
"paid_at": z.optional(z.string()),
"payment_gateway": z.optional(z.string()),
"payment_method": z.optional(z.string()),
"status": z.optional(z.enum(["pending", "succeeded", "canceled"])),
"visit_group_id": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsCompanyPaymentOutput>